import React from "react";
import { useParams, Navigate } from "react-router-dom";
import PageShell from "../components/PageShell";
import GuiasIndex from "../components/GuiasIndex";
import RunFlatBMW from "../components/articles/RunFlatBMW";
import HankookVsMichelin from "../components/articles/HankookVsMichelin";

const ARTICLE_MAP = {
  "run-flat-bmw": RunFlatBMW,
  "hankook-prime4-vs-michelin-primacy5": HankookVsMichelin,
};

export default function GuiasPage() {
  const { slug } = useParams();

  if (!slug) {
    return (
      <PageShell testId="page-guias">
        <GuiasIndex />
      </PageShell>
    );
  }

  const Article = ARTICLE_MAP[slug];
  if (!Article) {
    return <Navigate to="/guias" replace />;
  }

  return (
    <PageShell testId={`page-guia-${slug}`}>
      <Article />
    </PageShell>
  );
}
